import { HighlightCard } from "./HighlightCard";
import { RivalCard } from "./RivalCard";

/**
 * Format number with commas (e.g., 6420 -> 6,420)
 */
function formatNumber(num: number): string {
  return num.toLocaleString();
}

/**
 * Format rank with suffix (1st, 2nd, 3rd, etc.)
 */
function formatRank(rank: number): string {
  if (rank === 1) return "1st";
  if (rank === 2) return "2nd";
  if (rank === 3) return "3rd";
  return `${rank}th`;
}

interface ChallengeHighlightsProps {
  finalRank: number | null;
  totalParticipants: number;
  clubTotalDistance: number;
  closestRival: {
    username: string | null;
    avatarUrl: string | null;
    distanceAhead: number;
  } | null;
  isWinner?: boolean;
}

export function ChallengeHighlights({
  finalRank,
  totalParticipants,
  clubTotalDistance,
  closestRival,
  isWinner = true,
}: ChallengeHighlightsProps) {
  // Final Rank card colors - gold for winners, neutral for losers
  const rankIconBgColor = isWinner
    ? "rgba(255, 215, 0, 0.2)"
    : "rgba(255, 255, 255, 0.05)";
  const rankIconColor = isWinner
    ? "rgb(255, 215, 0)"
    : "rgba(255, 255, 255, 0.8)";

  return (
    <div className="px-4">
      <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
        <span className="material-symbols-outlined text-primary">
          auto_awesome
        </span>
        Challenge Highlights
      </h3>

      <div className="grid grid-cols-1 gap-4">
        {/* Rank + Club Total */}
        <div className="grid grid-cols-2 gap-4">
          {/* Final Rank */}
          <HighlightCard
            icon="leaderboard"
            iconBgColor={rankIconBgColor}
            iconColor={rankIconColor}
            label="Final Rank"
            value={finalRank ? formatRank(finalRank) : "N/A"}
            suffix={`/ ${totalParticipants}`}
          />

          {/* Club Total */}
          <HighlightCard
            icon="groups"
            iconBgColor="rgba(255, 0, 127, 0.2)"
            iconColor="rgb(255, 0, 127)"
            label="Club Total"
            value={formatNumber(Math.round(clubTotalDistance))}
            suffix="km"
          />
        </div>

        {/* Closest Rival */}
        {closestRival && (
          <RivalCard
            username={closestRival.username}
            avatarUrl={closestRival.avatarUrl}
            distanceAhead={closestRival.distanceAhead}
            isWinner={isWinner}
          />
        )}
      </div>
    </div>
  );
}
